module.exports = (__webpack_require__(2))("./loader/justep-css-loader/lib/css-base.js");


//////////////////
// WEBPACK FOOTER
// delegated ./loader/justep-css-loader/lib/css-base.js from dll-reference base
// module id = 36
// module chunks = 22